import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Button, DialogActions, DialogContent, TextField } from '@mui/material';
import { ModalActionProps } from 'models/AutoModals';
import { VoyageModel } from 'models/VoyageModel';
import { CompanyModel } from 'models/CompanyModel';
import Api from 'utils/api';


type DeliveryFaxPreviewDialogProps = {
    voyage: VoyageModel,
    company: CompanyModel,
    type: string
} & ModalActionProps<string>

const DeliveryFaxPreviewDialog = ({voyage, company, type, onFinish}: DeliveryFaxPreviewDialogProps) => {
    const {t} = useTranslation();
    const [message, setMessage] = useState('');

    useEffect(() => {
        Api.voyages.deliveryFaxPreview(voyage.id, company.id, type)
            .then(res => setMessage(res.data.message));
    }, []);

    const submit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        onFinish(message);
    };

    return (
        <Box component="form" onSubmit={submit}>
            <DialogContent>
                <TextField
                    id="message"
                    name="message"
                    label={t('content')}
                    required
                    fullWidth
                    multiline
                    rows={15}
                    variant="outlined"
                    value={message}
                    onChange={e => setMessage(e.target.value)}
                />
            </DialogContent>

            <DialogActions>
                <Button type="submit">{t('send')}</Button>
            </DialogActions>
        </Box>
    );
};

export default DeliveryFaxPreviewDialog;
